import * as classNames from 'classnames';
import { MainNavigation as Navigation } from '../../main/MainNavigation';
import * as React from 'react';
import style from './SideNavigation.less';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

export interface MainNavigationProps {
    data: any;
    id: number;
    onModulSelection: (modul: string) => void;
    onRoutingChange: (routing: any) => void;
}

export interface MainNavigationState {
    backgroundColor: string;
    color: string;
    curNode: any;
    curModul: any;
    navigation: any[];
    openItems: any;
    nodePath: any[];
}

export class MainNavigation extends React.Component<MainNavigationProps, MainNavigationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            backgroundColor: 'inherit',
            curNode: {},
            color: 'inherit',
            curModul: null,
            navigation: null,
            openItems: {},
            nodePath: [],
        };
    }

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.id !== prevProps.id) {
            this.init();
        }
    }

    init(): void {
        const navigation: any = Navigation.getData() || [];
        const node: any = navigation[0] || {};
        const backgroundColor: string = node.bgcolor || this.state.backgroundColor;
        const color: string = node.color || this.state.color;
        const curModul: string = (this.props.data || {}).MODUL_SELECTED;
        this.setState({ backgroundColor, color, curModul, navigation }, () => console.info('MAIN-INIT:', this.props.id, curModul, navigation));
        this.toggleItem({ name: 'E-Tool Module' }, 0);
    }

    isCurrentNode(item: any): boolean {
        return item.modul === this.state.curModul;
    }

    onRoutingChange(data: any): void {
        this.setState({ curNode: data || {} }, () => {
            console.log('onRoutingChange', data);
            this.toggleItem(data.item, data.level);
            this.props.onRoutingChange(this.state.curNode);
        });
    }

    render(): JSX.Element {
        if (this.state.navigation === null) {
            return <WSpinner />;
        }

        return (
            <div className={style.wrapper}>
                <div className={style[`area-${this.props.id}`]}>
                    {this.renderGroup(this.state.navigation, 0)}
                </div>
            </div>
        );
    }

    renderChildren(item: any, level: number): JSX.Element {
        const classNameCurrent: string = this.isCurrentNode(item) ? style.current : null;

        return (
            <div
                className={classNames(style[`level-${level}`], classNameCurrent)}
                style={{
                    color: item.color ? item.color : this.state.color,
                    backgroundColor: item.bgcolor ? item.bgcolor : this.state.backgroundColor,
                    cursor: (level && (!item.children || !level)) && (item.path || item.modul) && 'pointer',
                    marginLeft: level * (level > 1 ? 15 : 20)
                }}
                onClick={() => !(item.children || []).length
                    ? (typeof item.modul === 'string'
                        ? this.props.onModulSelection(item.modul)
                        : this.onRoutingChange({ path: item.path || {}, entities: item.entities || [], item: item || {}, level })
                    )
                    : null
                }
                // onClick={() => !(item.children || []).length
                //     ? this.onRoutingChange({ path: item.path || {}, entities: item.entities || [], item: item || {}, level })
                //     : this.toggleItem(item, level)
                // }
            >
                {item.name}{this.renderToggle(item, level)}
            </div>
        );
    }

    renderGroup(data: any[], level: number): JSX.Element[] {
        return (data || []).map((item: any, index: number) => {
            if (item.disabled || false) {
                return null;
            }
            const children: any[] = item.children || [];

            if (level === 0) {
                return (
                    <div key={`group-${index}`}>
                        {this.renderChildren(item, level)}
                        {!!this.state.openItems[item.name] && !!children.length && this.renderGroup(children, level + 1)}
                    </div>
                );
            }

            return (
                <React.Fragment key={`site-${level}-${index}`}>
                    {this.renderChildren(item, level)}
                    {!!children.length && this.renderGroup(children, level + 1)}
                </React.Fragment>
            );
        });
    }

    renderToggle(item: any, level: number): JSX.Element {
        return (
            <div style={{ float: 'right' }}>
                {
                    !!(item.children || []).length
                        ? !!this.state.openItems[item.name]
                            ? (!level ? '▼' : '▽')
                            : (!level ? '▶' : '▽')
                        : ''
                }
            </div>
        );
    }

    toggleItem(item: any, level: number): void {
        if (level) {
            return;
        }
        const stateOpenItems = this.state.openItems;
        const name = item.name;
        const openItems: any = {};

        if (!stateOpenItems[name]) {
            openItems[name] = true;
        }
        this.setState({ openItems });
    }
}
